import React from 'react';
import '../../pages/style.css';
import ProjectCard from './ProjectCard';
import { Container, Row, Col } from 'react-bootstrap';
import cyoa from '../../Assets/CYOA.png';
import store from '../../Assets/Store.png';
import borgwebsite from '../../Assets/Borgwebsite.png';
import chatmodal from '../../Assets/ChatModal.png';
import weatherapp from '../../Assets/WeatherApp.png';
import ecommerce from '../../Assets/Ecommerce.png';

function Projectlist() {
  return (
    <div className="projectbackground">
      <Container fluid className="project-section">
        <Container>
          <Row style={{ justifyContent: 'center', paddingBottom: '10px' }}>
            <Col lg={4} md={6} sm={12} className="project-card">
              <ProjectCard
                imgPath={cyoa}
                title="CYOA Forum Game"
                description="Interactive choose‑your‑own‑adventure forum where users create threads, post responses, and manage discussions in real time."
                tech={['React', 'Node.js', 'MongoDB', 'Express']}
                ghLink="https://github.com/donaldlopez82/CYOA-Forum-Game.git"
              />
            </Col>

            <Col lg={4} md={6} sm={12} className="project-card">
              <ProjectCard
                imgPath={store}
                title="ComicBuy Store"
                description="Full‑stack MERN e‑commerce application designed for comic collectors to browse and purchase collectibles."
                tech={['MongoDB', 'Express', 'React', 'Node.js']}
                ghLink="https://github.com/donaldlopez82/ComicBuy.git"
              />
            </Col>

            <Col lg={4} md={6} sm={12} className="project-card">
              <ProjectCard
                imgPath={borgwebsite}
                title="Borg Website"
                description="Modern responsive website demonstrating component‑based UI design and scalable frontend architecture."
                tech={['React', 'Node.js', 'MongoDB', 'Express']}
                ghLink="https://github.com/donaldlopez82/Borg-Website.git"
              />
            </Col>

            <Col lg={4} md={6} sm={12} className="project-card">
              <ProjectCard
                imgPath={chatmodal}
                title="React Firebase Chat"
                description="Real‑time chat application allowing authenticated users to send and receive instant messages using Firebase services."
                tech={['React', 'Firebase', 'JavaScript', 'CSS']}
                ghLink="https://github.com/donaldlopez82/react-firebase-chat.git"
              />
            </Col>

            <Col lg={4} md={6} sm={12} className="project-card">
              <ProjectCard
                imgPath={weatherapp}
                title="Weather Dashboard"
                description="Weather search application that retrieves real‑time weather data from an API based on user input."
                tech={['JavaScript', 'HTML', 'CSS', 'Weather API']}
                ghLink="https://github.com/donaldlopez82/WeatherApp.git"
              />
            </Col>

            <Col lg={4} md={6} sm={12} className="project-card">
              <ProjectCard
                imgPath={ecommerce}
                title="Comics & Collectibles Shop"
                description="Full‑stack online store where users can browse comic books, view products, and manage a shopping cart."
                tech={['React', 'Node.js', 'MongoDB', 'Express']}
                ghLink="https://github.com/donaldlopez82/Ecommerce.git"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default Projectlist;
